<template>
    <v-textarea :label="label" v-model="text" hint="One phone per line" rows="8" placeholder="One phone number per line"/>
</template>

<script>
    export default {
        name: "ChooseNumbers",
        props: {
            label: {},
            value: {},
            url: {
                type: String,
                default() {
                    return this.api.ACTIONS.LOCATIONS
                }
            },
            initialSearchParams: {
                type: URLSearchParams,
                default: () => new URLSearchParams()
            },
            multi: {
                type: Boolean,
                default: true
            },
            returnObject: {
                type: Boolean,
                default: false
            },
            rules: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                text: ""
            }
        },
        watch: {
            data(val) {
                this.$emit("input", val);
            }
        },
        computed: {
            data() {
                return this.text.split("\n");
            }
        }
    }
</script>

<style scoped>

</style>